// Etiquetas y formatos compartidos por la lista, el detalle y el Excel de nómina.

// Recargos: horas dentro de la base que además llevan recargo (se pagan solo con el %).
// Extras: horas sobre la base (se pagan con la hora completa más el %).
export const GRUPOS_HORAS = [
  {
    grupo: 'Ordinarias',
    tipos: [{ key: 'ordinarias', label: 'Ordinarias', largo: 'Horas ordinarias · básico (salario ÷ 30 × días)' }],
  },
  {
    grupo: 'Recargos',
    tipos: [
      { key: 'recargoNocturno', label: 'Nocturno', largo: 'Recargo nocturno' },
      { key: 'recargoDominicalDiurno', label: 'Dom. diurno', largo: 'Recargo dominical diurno' },
      { key: 'recargoDominicalNocturno', label: 'Dom. nocturno', largo: 'Recargo dominical nocturno' },
      { key: 'recargoFestivoDiurno', label: 'Fest. diurno', largo: 'Recargo festivo diurno' },
      { key: 'recargoFestivoNocturno', label: 'Fest. nocturno', largo: 'Recargo festivo nocturno' },
    ],
  },
  {
    grupo: 'Extras',
    tipos: [
      { key: 'extraDiurna', label: 'Diurna', largo: 'Extra diurna' },
      { key: 'extraNocturna', label: 'Nocturna', largo: 'Extra nocturna' },
      { key: 'extraDominicalDiurna', label: 'Dom. diurna', largo: 'Extra dominical diurna' },
      { key: 'extraDominicalNocturna', label: 'Dom. nocturna', largo: 'Extra dominical nocturna' },
      { key: 'extraFestivaDiurna', label: 'Fest. diurna', largo: 'Extra festiva diurna' },
      { key: 'extraFestivaNocturna', label: 'Fest. nocturna', largo: 'Extra festiva nocturna' },
    ],
  },
  {
    grupo: 'Ausencias',
    tipos: [
      { key: 'incapacidad', label: 'Incapacidad', largo: 'Incapacidad' },
      { key: 'permisoRemunerado', label: 'Permiso rem.', largo: 'Permiso remunerado' },
      { key: 'permisoNoRemunerado', label: 'Permiso no rem.', largo: 'Permiso no remunerado' },
    ],
  },
];

export const TIPOS_HORAS = GRUPOS_HORAS.flatMap((g) => g.tipos.map((t) => ({ ...t, grupo: g.grupo })));

export const ETIQUETA_TIPO = Object.fromEntries(TIPOS_HORAS.map((t) => [t.key, t.largo]));

export const sumaGrupo = (obj, grupo) =>
  (GRUPOS_HORAS.find((g) => g.grupo === grupo)?.tipos || []).reduce((s, t) => s + (Number(obj?.[t.key]) || 0), 0);

export const ESTADOS = {
  borrador: { label: 'Borrador', variant: 'secondary' },
  aprobada: { label: 'Aprobada', variant: 'default' },
  pagada: { label: 'Pagada', variant: 'outline' },
  anulada: { label: 'Anulada', variant: 'destructive' },
};

export const TIPOS_NOMINA = {
  quincenal: 'Quincenal',
  mensual: 'Mensual',
  otro: 'Otro periodo',
};

export const pesos = (v) =>
  Number(v || 0).toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });

export const horas = (v) => {
  const n = Number(v || 0);
  return n ? n.toLocaleString('es-CO', { maximumFractionDigits: 2 }) : '—';
};

export const fechaCorta = (iso) => {
  if (!iso) return '—';
  const [a, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  return new Date(a, m - 1, d).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const diaSemana = (iso) => {
  const [a, m, d] = String(iso).split('-').map(Number);
  return new Date(a, m - 1, d).toLocaleDateString('es-CO', { weekday: 'short' });
};

const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

/** Igual que el backend: "quincena-1-sep-2026", "mensual-sep-2026"… */
export const nombreSugerido = (desde, hasta, tipo) => {
  if (!desde || !hasta) return '';
  const [anio, mes, dia] = desde.split('-');
  const mesTxt = MESES[Number(mes) - 1];
  if (tipo === 'quincenal') return `quincena-${Number(dia) <= 15 ? 1 : 2}-${mesTxt}-${anio}`;
  if (tipo === 'mensual') return `mensual-${mesTxt}-${anio}`;
  return `nomina-${desde}-a-${hasta}`;
};

const pad = (n) => String(n).padStart(2, '0');

/** Fechas de la quincena o el mes que contiene `iso` (yyyy-MM-dd). */
export const periodoPorTipo = (tipo, iso) => {
  const [a, m, d] = iso.split('-').map(Number);
  const ultimo = new Date(a, m, 0).getDate();
  if (tipo === 'mensual') return { desde: `${a}-${pad(m)}-01`, hasta: `${a}-${pad(m)}-${pad(ultimo)}` };
  if (d <= 15) return { desde: `${a}-${pad(m)}-01`, hasta: `${a}-${pad(m)}-15` };
  return { desde: `${a}-${pad(m)}-16`, hasta: `${a}-${pad(m)}-${pad(ultimo)}` };
};
